export enum DisplaySizes {
  TWO_XL = '2xl',
  XL = 'xl',
  LG = 'lg',
  MD = 'md',
  SM = 'sm',
  XS = 'xs',
}
